CustomEvent = require './custom-event'

module.exports = (targets, eventName, options) ->
  event = new CustomEvent eventName,
    bubbles: false
    cancelable: false
    detail: options.detail ? undefined

  stopped = false

  event.stopPropagation = ->
    stopped = true
    CustomEvent::stopPropagation.apply(this, arguments)

  for target in targets when !stopped
    target.dispatchEvent(event)

  return

